import { Checkbox, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import globalUseStyles from '../../styles/globalCustomStyles';

const ChoosePublicHolidaysButton = (props) => {
    const t = useTranslate();
    const globalClasses = globalUseStyles();
    const publicHolidays = props.publicHolidays;
    const setPublicHolidays = props.setPublicHolidays;

    return (
        <div className={globalClasses.dayCheckbox}>
            <Typography variant="h9" style={{ marginRight: '10px' }}>{t('resources.global.public_holidays_button')}</Typography>
            <Checkbox
                checked={publicHolidays}
                onChange={() => setPublicHolidays(!publicHolidays)}
            />
        </div>
    );
};

export default ChoosePublicHolidaysButton;